// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  width: 100%;
  height: auto;
  min-height: calc(100vh - 96px);
  margin: 0 auto;
}

.home__container {
  margin: 20px 0;
  background-color: #fff;
  padding: 20px 40px;
}

.main-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.id__card__preview {
  width: 516px;
  margin-top: 16px;
  border: #EDF1F3 solid 5px;
}

.id__card__preview__heading {
  margin-top: 20px;
  height: 20px;
}

.id__card__preview__heading p {
  margin-left: 35px;
}

.id__card__preview__cards {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 362px;
}`, "",{"version":3,"sources":["webpack://./src/components/home/Home.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".home {\n  width: 100%;\n  height: auto;\n  min-height: calc(100vh - 96px);\n  margin: 0 auto;\n}\n\n.home__container {\n  margin: 20px 0;\n  background-color: #fff;\n  padding: 20px 40px;\n}\n\n.main-content {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.id__card__preview {\n  width: 516px;\n  margin-top: 16px;\n  border: #EDF1F3 solid 5px;\n}\n\n.id__card__preview__heading {\n  margin-top: 20px;\n  height: 20px;\n}\n\n.id__card__preview__heading p {\n  margin-left: 35px;\n}\n\n.id__card__preview__cards {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 362px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
